module.exports = __webpack_public_path__ + "img/٢٠٢٠٠٧٢٥_١٤٠٣٢١2.da82c6f8.png";